import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';

import de from 'locales/de';
import en from 'locales/en';
import es from 'locales/es';
import fr from 'locales/fr';
import hi from 'locales/hi';
import it from 'locales/it';
import ja from 'locales/ja';
import pt from 'locales/pt';
import zh from 'locales/zh';
import { APP_LANGUAGE_CODES } from './constants/appLanguages';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
	de: {
		translation: de
	},
	en: {
		translation: en
	},
	es: {
		translation: es
	},
	fr: {
		translation: fr
	},
	hi: {
		translation: hi
	},
	it: {
		translation: it
	},
	ja: {
		translation: ja
	},
	pt: {
		translation: pt
	},
	zh: {
		translation: zh
	}
};

i18n.use(initReactI18next) // passes i18n down to react-i18next
	.use(detector)
	.init({
		resources,

		fallbackLng: 'en',
		supportedLngs: [...APP_LANGUAGE_CODES],
		load: 'languageOnly',
		nonExplicitSupportedLngs: true,

		keySeparator: '.',

		interpolation: {
			escapeValue: false // react already safes from xss
		}
	});

export default i18n;
